import React, {Component} from 'react';
import Logger from "../../helpers/Logger";
import SearchComponent from "./SearchComponent";

export default class SearchComponentCotnainer extends Component {
    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in SearchComponentCotnainer', error.toString());
    }

    render() {
        return (<SearchComponent parameters={this.props.parameters} translations={this.props.translations}/>);
    }
}



// WEBPACK FOOTER //
// ./src/components/mobile/SearchComponentCotnainer.js